import React, { Dispatch, SetStateAction, useState } from 'react';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { InvoiceDA } from '../../services/admin/invoice.service';
import { GlobalSwal } from '../../styles/swal.style';
import { Company } from '../../models/company.model';
import { Error } from '../../models/error.model';
import { Invoice } from '../../models/invoice.model';
import { modalHide } from '../../utils/modal.util';
import { getError } from '../../languages/translations/response';
import { errorWebHandler } from '../../scripts/error.web.handler.script';

import AppLoading from '../Loading';

export interface AppModalInvoiceUpdateInvalidateProps {
  companyForUser: Company | null
  invoice: Invoice | null,
  setInvoice: Dispatch<SetStateAction<Invoice | null>>
};

let errorResponse: Error, invoiceResponse: Invoice;

const AppModalInvoiceUpdateInvalidate: React.FunctionComponent<AppModalInvoiceUpdateInvalidateProps> = ({companyForUser, invoice, setInvoice}) => {
  const {lang} = StateLanguage()

  const [loadIndicator, setLoadIndicator] = useState('off')

  const submitInvoiceInvalidate = async () => {
    setLoadIndicator('on')

    if (companyForUser && invoice) {
      await InvoiceDA.putInvoiceStatus(companyForUser.id, invoice.id, null, null, null).then( (response) => {
        if (response.status === 200) {
          invoiceResponse = response.data
          setInvoice(invoiceResponse)

          GlobalSwal.fire({
            title: lang.labels.successfullyUpdatedStatus,
            text: lang.labels.actionCompletedReturningToPage,
            icon: 'success',
            showConfirmButton: false,
            timer: 2200
          }).then( () => {
            executeHideModalInvoiceUpdateInvalidate()
          })
        } else {
          errorResponse = response.data

          GlobalSwal.fire({
            title: getError(errorResponse.code, lang.code, errorResponse.message),
            text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
            icon: 'error',
            showConfirmButton: false,
            timer: 2200
          })
        }
      }).catch( (error) => {
        errorWebHandler(lang, error)
      }).finally(() => {
        setLoadIndicator('off')
      })
    }
  }

  const executeHideModalInvoiceUpdateInvalidate = () => {
    modalHide('modal-invoice-update-invalidate')
  }

  return (
    <div id="modal-invoice-update-invalidate" className="modal fade" tabIndex={-1} aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="text-capitalize">{lang.labels.invalidateInvoice}</h2>
          </div>
          <div className="modal-body">
            { invoice
              ?
              <div className="text-justify fw-semibold">
                {lang.labels.ifYouInvalidateInvoice}
                <strong className=" ms-1">{invoice.invoice_number}</strong>
                {lang.labels.theAssociatedAccountingEntriesWillBeDeletedInvoice}
                <br /><br />
                {lang.labels.toPerformAnySubsequentActionWithInvoice}
              </div>
              :
              <AppLoading></AppLoading>
            }
          </div>
          <div className="modal-footer flex-center">
            <button className="btn btn-secondary mx-2" type="reset" onClick={executeHideModalInvoiceUpdateInvalidate}>{lang.labels.noCancel}</button>
            <button className="btn btn-primary mx-2" type="button" data-kt-indicator={loadIndicator} onClick={submitInvoiceInvalidate}>
              <span className="indicator-label">{lang.labels.yesInvalidate}</span>
              <span className="indicator-progress">
                {lang.labels.pleaseWait}
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
};

export default AppModalInvoiceUpdateInvalidate;
